import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "generateBtn", "copyBtn"]

  connect() {
    this.updateCopyButtonState()
  }

  generatePassword() {
    const charset = "0123456789"
    const length = 12
    let password = ""
    
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length))
    }
    
    this.fieldTarget.value = password
    this.updateCopyButtonState()
    
    // Показываем уведомление о генерации
    this.showNotification("Пароль сгенерирован")
  }

  copyPassword() {
    if (this.fieldTarget.value.trim() === "") {
      this.showNotification("Нечего копировать", "error")
      return
    }

    navigator.clipboard.writeText(this.fieldTarget.value).then(() => {
      this.showNotification("Пароль скопирован в буфер обмена")
    }).catch(() => {
      // Fallback для старых браузеров
      this.fieldTarget.select()
      document.execCommand('copy')
      this.showNotification("Пароль скопирован в буфер обмена")
    })
  }

  updateCopyButtonState() {
    const hasPassword = this.fieldTarget.value.trim() !== ""
    this.copyBtnTarget.disabled = !hasPassword
    this.copyBtnTarget.classList.toggle("opacity-50", !hasPassword)
  }

  showNotification(message, type = "success") {
    // Создаем простое уведомление
    const notification = document.createElement("div")
    notification.className = `fixed top-4 right-4 px-4 py-2 rounded shadow-lg z-50 ${
      type === "success" ? "bg-green-500 text-white" : "bg-red-500 text-white"
    }`
    notification.textContent = message
    
    document.body.appendChild(notification)
    
    // Удаляем уведомление через 3 секунды
    setTimeout(() => {
      notification.remove()
    }, 3000)
  }

  fieldTargetConnected() {
    this.fieldTarget.addEventListener("input", () => this.updateCopyButtonState())
  }
}
